export default "__VITE_ASSET__nLIBIwdR__"